<section *ngIf="shouldAskProductTypeQuestion" class="product-type-question">
  <p class="product-type-question__title">
    {{ productTypeQuestionTitle }}
  </p>
  <section class="product-type-options" [class.selection-made]="selectedOption">
    <label
      *ngFor="let option of options; let i = index"
      class="product-type-option"
      [class.selected]="selectedOption === option"
      [attr.data-testid]="'product-type-option-' + i"
    >
      <input
        type="radio"
        [name]="'productType-' + claimType"
        [value]="option"
        [checked]="selectedOption === option"
        (change)="handleSelection(option)"
      />
      <div class="radio"></div>
      <span>{{ formatOption(option) | capitalcase }}</span>
    </label>
  </section>
</section>

<section class="gas-safety-question" *ngIf="shouldShowGasSafetyQuestion">
  <p class="gas-safety-question__title">
    Do you smell gas or think there's a carbon monoxide leak?
  </p>
  <section class="gas-safety-options">
    <label
      *ngFor="let answer of gasSafetyAnswers"
      class="gas-safety-option"
      [class.selected]="gasSafetyAnswer === answer"
      [attr.data-testid]="answer === 'YES' ? 'gas-option-yes' : 'gas-option-no'"
    >
      <input
        type="radio"
        [name]="'gasSafety-' + claimType"
        [value]="answer"
        [checked]="gasSafetyAnswer === answer"
        (change)="handleGasSafetySelection(answer)"
      />
      <div class="radio"></div>
      <span>{{ answer === 'YES' ? 'Yes' : 'No' }}</span>
    </label>
  </section>
</section>

<section
  class="gas-emergency-followup"
  *ngIf="shouldShowGasSafetyQuestion && gasSafetyAnswer === 'YES'"
>
  <p class="gas-emergency-followup__title">
    <i class="fa-light fa-circle-exclamation fa-lg error-icon"></i>
    What are you reporting?
  </p>
  <section class="gas-emergency-reasons">
    <label
      *ngFor="let reason of gasEmergencyReasons; let i = index"
      class="gas-emergency-option"
      [class.selected]="gasEmergencyReason === reason.value"
      [attr.data-testid]="'gas-emergency-option-' + i"
    >
      <input
        type="radio"
        [name]="'gasEmergencyReason-' + claimType"
        [value]="reason.value"
        [checked]="gasEmergencyReason === reason.value"
        (change)="handleGasEmergencyReasonSelection(reason.value)"
      />
      <div class="radio"></div>
      <span>{{ reason.label }}</span>
    </label>
  </section>
</section>

<section class="gas-safety-help" *ngIf="showGasEmergencyContent">
  <div class="gas-safety-help__devider">
    <h4>Call the National Gas Emergency Service</h4>

    <section class="hint">
      We can’t book a repair if there’s a suspected gas or carbon monoxide leak.
    </section>
    <p class="body blocked">
      If you smell gas or have any concerns, call the National Gas Emergency
      Service. It’s free and open any time. They’ll check your supply and make
      sure everything’s safe.
    </p>

    <section class="numbers">
      <section class="number" *ngFor="let contact of gasEmergencyContacts">
        <p class="label">{{ contact.area }}</p>
        <a
          class="call-link"
          [class.call-link--disabled]="!isCallLinkInteractive"
          [attr.href]="isCallLinkInteractive ? contact.href : null"
          [attr.tabindex]="isCallLinkInteractive ? null : '-1'"
          [attr.aria-disabled]="!isCallLinkInteractive ? 'true' : null"
          (click)="handleCallLinkClick($event)"
        >
          <i class="fa-light fa-phone call-link__icon" aria-hidden="true"></i>
          <span class="call-link__text">{{ contact.displayNumber }}</span>
        </a>
      </section>
    </section>

    <p class="website-link body">
      Or visit
      <a
        class="link-text"
        href="https://www.nationalgas.com/emergency-contacts"
        target="_blank"
        >www.nationalgas.com</a
      >
    </p>
  </div>
</section>
